import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function Rapor() {
  const [filters, setFilters] = useState({
    baslangic: '',
    bitis: '',
    birim_id: '',
    personel_id: ''
  });
  
  const [ziyaretciler, setZiyaretciler] = useState([]);
  const [birimler, setBirimler] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quickFilter, setQuickFilter] = useState('');
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchBirimler();
    fetchPersoneller();
  }, []);

  const fetchBirimler = async () => {
    try {
      const response = await api.get('/birimler');
      setBirimler(response.data);
    } catch (error) {
      console.error('Birimler yüklenemedi:', error);
    }
  };

  const fetchPersoneller = async () => {
    try {
      const response = await api.get('/personeller');
      setPersoneller(response.data);
    } catch (error) {
      console.error('Personeller yüklenemedi:', error);
    }
  };

  const handleQuickFilter = (type) => {
    const today = new Date();
    let baslangic, bitis;

    switch(type) {
      case 'bugun':
        baslangic = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        bitis = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        break;
      case 'hafta':
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay() + 1);
        baslangic = new Date(weekStart.setHours(0, 0, 0, 0)).toISOString();
        bitis = new Date().toISOString();
        break;
      case 'ay':
        baslangic = new Date(today.getFullYear(), today.getMonth(), 1).toISOString();
        bitis = new Date().toISOString();
        break;
      case 'yil':
        baslangic = new Date(today.getFullYear(), 0, 1).toISOString();
        bitis = new Date().toISOString();
        break;
      default:
        baslangic = '';
        bitis = '';
    }

    setFilters({ ...filters, baslangic, bitis });
    setQuickFilter(type);
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.baslangic) params.append('baslangic', filters.baslangic);
      if (filters.bitis) params.append('bitis', filters.bitis);
      if (filters.birim_id) params.append('birim_id', filters.birim_id);
      if (filters.personel_id) params.append('personel_id', filters.personel_id);

      const response = await api.get(`/ziyaretciler/rapor?${params.toString()}`);
      setZiyaretciler(response.data);
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || 'Rapor yüklenemedi'));
    } finally {
      setLoading(false);
    }
  };

const handleDownloadPDF = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.baslangic) params.append('baslangic', filters.baslangic);
      if (filters.bitis) params.append('bitis', filters.bitis);
      if (filters.birim_id) params.append('birim_id', filters.birim_id);
      if (filters.personel_id) params.append('personel_id', filters.personel_id);

      const response = await api.get(`/pdf/rapor?${params.toString()}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `ziyaretci-raporu-${new Date().toLocaleDateString('tr-TR')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      alert('PDF indirilemedi: ' + (error.response?.data?.error || 'Hata oluştu'));
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('tr-TR');
  };

  return (
    <div className="container">
      <div className="nav">
        <button onClick={() => navigate('/admin/dashboard')} className="btn btn-secondary">
          ← Geri
        </button>
        <button onClick={() => navigate('/admin/grafik')} className="btn btn-secondary">
          Grafikler
        </button>
      </div>

      <div className="card">
        <h2 style={{ color: '#ff0000' }}>Ziyaretçi Raporları</h2>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px' }}>Hızlı Filtreler</h3>
          <button 
            onClick={() => handleQuickFilter('bugun')} 
            className={`btn ${quickFilter === 'bugun' ? 'btn-primary' : 'btn-secondary'}`}
          >
            Bugün
          </button>
          <button 
            onClick={() => handleQuickFilter('hafta')} 
            className={`btn ${quickFilter === 'hafta' ? 'btn-primary' : 'btn-secondary'}`}
          >
            Bu Hafta
          </button>
          <button 
            onClick={() => handleQuickFilter('ay')} 
            className={`btn ${quickFilter === 'ay' ? 'btn-primary' : 'btn-secondary'}`}
          >
            Bu Ay
          </button>
          <button 
            onClick={() => handleQuickFilter('yil')} 
            className={`btn ${quickFilter === 'yil' ? 'btn-primary' : 'btn-secondary'}`}
          >
            Bu Yıl
          </button>
          <button 
            onClick={() => { handleQuickFilter(''); setFilters({ baslangic: '', bitis: '', birim_id: '', personel_id: '' }); }} 
            className="btn btn-secondary"
          >
            Tümü
          </button>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px' }}>Detaylı Filtreler</h3>
          
          <div className="form-group">
            <label>Başlangıç Tarihi</label>
            <input
              type="datetime-local"
              value={filters.baslangic ? filters.baslangic.slice(0, 16) : ''}
              onChange={(e) => setFilters({ ...filters, baslangic: e.target.value ? new Date(e.target.value).toISOString() : '' })}
            />
          </div>

          <div className="form-group">
            <label>Bitiş Tarihi</label>
            <input
              type="datetime-local"
              value={filters.bitis ? filters.bitis.slice(0, 16) : ''}
              onChange={(e) => setFilters({ ...filters, bitis: e.target.value ? new Date(e.target.value).toISOString() : '' })}
            />
          </div>

          <div className="form-group">
            <label>Birim</label>
            <select
              value={filters.birim_id}
              onChange={(e) => setFilters({ ...filters, birim_id: e.target.value })}
            >
              <option value="">-- Tüm Birimler --</option>
              {birimler.map(b => (
                <option key={b.id} value={b.id}>{b.birim_adi}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Personel</label>
            <select
              value={filters.personel_id}
              onChange={(e) => setFilters({ ...filters, personel_id: e.target.value })}
            >
              <option value="">-- Tüm Personeller --</option>
              {personeller.map(p => (
                <option key={p.id} value={p.id}>{p.ad_soyad}</option>
              ))}
            </select>
          </div>

          <button onClick={handleSearch} className="btn btn-primary">
            Rapor Oluştur
          </button>
        </div>
          <button 
            onClick={handleDownloadPDF} 
            className="btn btn-secondary"
            style={{ marginLeft: '10px' }}
          >
            📄 PDF İndir
          </button>

        {loading ? (
          <div className="loading">Yükleniyor...</div>
        ) : (
          <>
            <h3 style={{ color: '#ff0000', marginTop: '30px' }}>
              Toplam: {ziyaretciler.length} Ziyaretçi
            </h3>
            
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Ad Soyad</th>
                    <th>Firma</th>
                    <th>Ziyaret Türü</th>
                    <th>Birim</th>
                    <th>Personel</th>
                    <th>Geliş</th>
                    <th>Çıkış</th>
                  </tr>
                </thead>
                <tbody>
                  {ziyaretciler.map(z => (
                    <tr key={z.id}>
                      <td>{z.ad_soyad}</td>
                      <td>{z.firma_adi || '-'}</td>
                      <td>{z.ziyaret_turu}</td>
                      <td>{z.birim_adi || '-'}</td>
                      <td>{z.personel_adi || '-'}</td>
                      <td>{formatDate(z.gelis_zamani)}</td>
                      <td>{formatDate(z.cikis_zamani)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Rapor;
